export default async function GetNotifcationsApi(
  page,
  limit,
  status,
  positionId
) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    
    // Build URL with conditional limit parameter
    let url = `${process.env.REACT_APP_API_URL}v1/notifications?page=${page}&status=${status}&positionId=${positionId}`;
    if (limit !== undefined) {
      url += `&limit=${limit}`;
    }
    
    await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting notifications: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
